import React from 'react';
import styles from './styles.sass';

export default function PageSectionWithWave({
  backgroundClassName,
  backgroundImage,
  children,
  drawWavePoints,
  isHero,
  isLongSection,
  isShortSection,
  zIndex = 1,
}) {
  // viewbox puts stroke in 100 point coord system
  return (
    <div
      className={`${styles.backdrop} ${isHero ? styles.hero : ''} ${
        isLongSection ? styles.isLongSection : ''
      } ${isShortSection ? styles.isShortSection : ''}`}
      style={{
        zIndex, // override to 0 to move later drawings below top drawing, visually
      }}
    >
      <div className={`${styles.waveDrawing} ${backgroundClassName}`}>
        <svg>
          <defs>
            <clipPath id="anchorWaveHeader" clipPathUnits="objectBoundingBox">
              <path
                stroke="transparent"
                d={drawWavePoints}
                vectorEffect="non-scaling-stroke"
              />
            </clipPath>
          </defs>
        </svg>
        {backgroundImage && (
          <div
            className={styles.avatarBackground}
            style={{
              backgroundImage: `url('${backgroundImage}')`,
            }}
          />
        )}
      </div>
      <div className={styles.childContainer}>{children}</div>
    </div>
  );
}
